export default __webpack_public_path__ + "static/NBAA_logo-ed545764ff250b89541a6041a1c617ed.png";